import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'

export function NameToolTip({ children }) {
    const [showTooltip, setShowTooltip] = useState(false)
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 640)
        }
        checkMobile()
        window.addEventListener('resize', checkMobile)
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    const handleTooltipToggle = () => {
        if (isMobile) {
            setShowTooltip(!showTooltip)
        }
    }

    return (
        <div className='relative'>
            <div
                onMouseEnter={() => !isMobile && setShowTooltip(true)}
                onMouseLeave={() => !isMobile && setShowTooltip(false)}
                onBlurCapture={() => setShowTooltip(false)}
                onClick={handleTooltipToggle}
            >
                {children}
            </div>

            {showTooltip && (
                <>
                    {isMobile && <div className='fixed inset-0 z-40' onClick={() => setShowTooltip(false)} />}

                    <div
                        onClick={() => setShowTooltip(false)}
                        className={`
                        absolute top-full left-0 mt-2 z-50 w-full max-w-sm cursor-pointer
                        transition-all duration-300 ease-out transform
                        ${
                            showTooltip
                                ? 'opacity-100 translate-y-0 pointer-events-auto'
                                : 'opacity-0 -translate-y-2 pointer-events-none'
                        }
                    `}
                    >
                        <div className='absolute w-4 h-4 rotate-45 border-t border-l -top-2 left-6 bg-white/95 backdrop-blur-sm border-white/20'></div>

                        <div className='p-3 text-xs leading-relaxed text-gray-700 border shadow-xl bg-white/95 backdrop-blur-sm rounded-xl sm:p-4 border-white/20 sm:text-sm'>
                            <div className='flex items-start gap-2 sm:gap-3'>
                                <div className='flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-cyan-100 flex items-center justify-center mt-0.5'>
                                    <InformationCircleIcon className='w-3 h-3 text-cyan-600' />
                                </div>

                                <div>
                                    <p className='text-xs text-gray-600'>
                                        We use these names in messages to make BrightPath feel more personal. This
                                        information is never shared and doesn't identify you or your child.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
